import React from "react";
import Layout from "../../components/layout/Layout";
import { useLocation } from "react-router-dom";

export default function ViewBanner() {
  const location = useLocation();
  const data = location.state.data;

  return (
    <div>
      <Layout>
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View Banner</h2>
          </div>

          <div className="mt-10">
            <div className="my-6">
              <img
                src={`${process.env.REACT_APP_MEDIA_BASE_URL}/${data.imageUrl}`}
                className="h-[100px] w-[100px] rounded-full border-2"
                alt=""
              />
            </div>
          </div>

          <div className="mt-10">
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Banner Id</h6>
                <p className="mt-1">{data.bannerId}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Category Id</h6>
                <p className="mt-1">{data.categoryId}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Title</h6>
                <p className="mt-1">{data.title}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Status</h6>
                <p className="mt-1">{data.status}</p>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </Layout>
    </div>
  );
}
